import { EngagementStatus } from './engagement.model';

/** Human-readable label per status — used across all engagement UI. */
export const ENGAGEMENT_STATUS_LABEL: Record<EngagementStatus, string> = {
  draft: 'Scoping',
  quoted: 'Quote ready',
  funded: 'Funded',
  in_progress: 'In progress',
  in_review: 'In review',
  revising: 'Revising',
  completed: 'Completed',
  cancelled: 'Cancelled',
  disconnected: 'Closed',
};

export type EngagementTone = 'neutral' | 'active' | 'success' | 'warn';

/** Colour tone per status — drives the status dot colour. */
export const ENGAGEMENT_STATUS_TONE: Record<EngagementStatus, EngagementTone> = {
  draft: 'neutral',
  quoted: 'active',
  funded: 'active',
  in_progress: 'active',
  in_review: 'active',
  revising: 'warn',
  completed: 'success',
  cancelled: 'neutral',
  disconnected: 'neutral',
};